module.exports = __webpack_public_path__ + "img/certificate-1.ee5bbc8b.png";